var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',[_c('v-dialog',{attrs:{"max-width":"450"},model:{value:(_vm.promptDeleteDashboard),callback:function ($$v) {_vm.promptDeleteDashboard=$$v},expression:"promptDeleteDashboard"}},[_c('dashboard-delete')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }